import * as yup from 'yup';

export const dataBaseViewSchema = (t) =>
  yup.object({
    password: yup
      .string()
      .required(t('databaseBIUserSettings.requiredMessage')),
    retypePassword: yup
      .string()
      .required(t('databaseBIUserSettings.requiredRetypeMessage'))
      .oneOf(
        [yup.ref('password'), null],
        t('databaseBIUserSettings.passwordsMustMatch')
      )
  });
